export default __webpack_public_path__ + "static/media/sortImage.73708f37.svg";